import { render, staticRenderFns } from "./EmployeeRegister.vue?vue&type=template&id=2ca67e5c&scoped=true&"
import script from "./EmployeeRegister.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegister.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegister.vue?vue&type=style&index=0&id=2ca67e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca67e5c",
  null
  
)

export default component.exports